export enum ContactEnum {
  PARENT_1 = 'PARENT_1',
  PARENT_2 = 'PARENT_2',
  OTHER = 'OTHER'
}

export const contactEnumMapping: Record<ContactEnum, string> = {
  [ContactEnum.PARENT_1]: 'Parent 1',
  [ContactEnum.PARENT_2]: 'Parent 2',
  [ContactEnum.OTHER]: 'Autre'
}
